import { CSSProperties, MouseEvent, PropsWithChildren } from 'react';

import './Pressable.scss';

interface IProps {
  onPress: (event: MouseEvent<HTMLButtonElement>) => void;
  style?: CSSProperties;
  disabled?: boolean;
  dataCy?: string;
}

export const Pressable = ({
  onPress,
  children,
  style,
  disabled,
  dataCy,
}: PropsWithChildren<IProps>) => {
  const handleClick = (event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
    if (onPress) onPress(event);
  };

  return (
    <button
      type="button"
      className="pressable"
      data-cy={dataCy}
      onClick={handleClick}
      style={style}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
